import { useCallback, useRef } from "react";

/**
 * Returns a stable notifier that invokes `callback` at most once per mount —
 * later calls are no-ops. A ref backs the guard, not state, so calling it
 * never itself triggers a render. Useful where an optional callback prop must
 * fire once per session even though the caller's own action can run many
 * times (e.g. the first successful row mutation in a dialog session).
 */
export function useFireOnce(callback?: () => void): () => void {
  const firedRef = useRef(false);
  return useCallback(() => {
    if (firedRef.current) return;
    firedRef.current = true;
    callback?.();
  }, [callback]);
}
